module.exports = __webpack_public_path__ + "static/media/remove.2f8910ae.png";